angular.module('core').filter('resourceLabel', [ 'numberFilter',
  function($numberFilter) {
    return function(input, moduleName, resourceName) {

      var returnString = '';
      if (moduleName !== '') {
        returnString += moduleName + " - ";
      }

      if (resourceName !== '') {
        returnString += resourceName;
      } else {
        returnString.replace(" - ", "");
      }

      return returnString;
    };
  }
]);
